import { render, staticRenderFns } from "./off.vue?vue&type=template&id=5b2e81bd&scoped=true&"
import script from "./off.vue?vue&type=script&lang=js&"
export * from "./off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e81bd",
  null
  
)

export default component.exports